import React from 'react'
import InputField from '../../../sharedcomponents/1elements/Fields/InputField'
import { makeStyles } from '@material-ui/core/styles'

const LeftChild = ({ formikProps, editMode, createMode }) => {
  const classes = useStyles()
  const values = formikProps.values

  return (
    <div className={classes.root}>
      <InputField
        type='text'
        name='name'
        maxLength={150}
        required={true}
        label='Account Name'
        value={values?.name}
        editMode={editMode}
      />
      <InputField
        type='textarea'
        name='description'
        maxLength={150}
        required={false}
        label='Description'
        value={values?.description}
        editMode={editMode}
      />
      <div className={classes.dateWrapper}>
        <div className={classes.dateItem}>
          <InputField
            type='date'
            name='starts_at'
            maxLength={150}
            required={true}
            label='Create Date'
            value={values?.starts_at}
            editMode={editMode}
            setFieldValue={formikProps.setFieldValue}
          />
        </div>
        <div className={classes.dateItem}>
          <InputField
            type='date'
            name='expires_at'
            maxLength={150}
            required={true}
            label='Expiry Date'
            value={values?.expires_at}
            editMode={editMode}
            setFieldValue={formikProps.setFieldValue}
          />
        </div>
      </div>
      <InputField
        type='url'
        name='url'
        maxLength={150}
        required={false}
        label='Contract Url'
        value={values?.url}
        editMode={editMode}
      />
    </div>
  )
}

export default React.memo(LeftChild)

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    padding: '0 10px 0 0',
    '& >*': {
      boxSizing: 'border-box'
    }
  },
  dateWrapper: {
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  dateItem: {
    width: '45%',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start'
  }
}))
